import React, { useEffect } from "react";
import { icons } from "../../assets/icons";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import useApi from "../../hooks/useApi";
import { apiUrls } from "../../utils/api/apiUrls";
import SelectInput from "../FormFields/SelectInput";

const ToolbarHeader = ({
  title = "",
  showBack = true,
  renderLeft,
  renderRight,
  containerClassName = "",
  onBackClick,
  showStores = false,
  textClassCss = "text-[3rem]",
}) => {
  const { data = [], apiCall } = useApi();
  const {
    user = {},
    setStoreDropdownState,
    selectedStores,
    setSelectedStores,
    selectedManagers,
  } = useAuth();
  const getAllStoreApi = (am, rm="", finance="") => {
    let url = `${apiUrls.dmsService.getAllStores}${am}`
    if(finance){
      url = `${apiUrls.dmsService.getAllStores}${am}/${rm}/${finance}`
    }
    apiCall({
      url: url,
      method: "get",
      onSuccess: (data) => {
        setStoreDropdownState(data);
      },
    });
  };

  useEffect(() => {
    getAllStoreApi(selectedManagers?.storeDetails?.username || user?.username);
  }, [user?.username, selectedManagers?.storeDetails]);

  const navigate = useNavigate();
  const onClickBack = () => {
    if (onBackClick) {
      onBackClick();
      return;
    }
    navigate(-1);
  };

  return (
    <div className="flex flex-col gap-y-6">
      <div className={`flex justify-between ${containerClassName}`}>
        <div className="flex items-center gap-x-6">
          {showBack && (
            <div onClick={onClickBack}>
              <img
                src={icons.backIcon}
                alt="back icon"
                className="w-[2.7rem] h-[1.7rem] cursor-pointer"
              />
            </div>
          )}
          {renderLeft ? (
            renderLeft()
          ) : (
            <div
              className={`${textClassCss} font-family-medium text-[var(--blackColor)]`}
            >
              {title}
            </div>
          )}
        </div>
        {renderRight ? renderRight() : null}
      </div>
{/* 
      {user?.userLabel !== "Store" && showStores && (
        <SelectInput
          labelField="name"
          valueField="storeCode"
          options={[
            { name: "All", storeCode: "All" },
            ...data?.map((item) => ({
              name: `${item?.name} (${item?.storeCode})`,
              storeCode: item?.storeCode,
            })),
          ]}
          onChange={(val) => {
            console.log(val, "val");
            setSelectedStores({ storeDetails: val?.[0] });
          }}
          wrapperClassName="mb-4"
          onChangeFullRes
          value={
            selectedStores?.storeDetails?.storeCode
              ? selectedStores?.storeDetails?.storeCode
              : null
          }
        />
      )} */}
    </div>
  );
};

export default ToolbarHeader;
